import axiosInstance from "../../core/axiosConfig.ts";
export default class CourierService {
    async updateCourier(payload: any) {
        await axiosInstance.patch(
            '/admin/courier/update',
            payload
        );
    }

    async lockUnlockCourier(courierId: Number) {
        await axiosInstance.patch(
            `/admin/courier/lock-unlock?courierId=${courierId}`
        );
    }

    async getCourierList(){
        return await axiosInstance.get(
            '/admin/courier/list'
        );
    }

    async getCourierActiveList(restaurantId: number){
        return await axiosInstance.get(
            `/admin/courier/active-list?restaurantId=${restaurantId}`
        );
    }

    async getLastLocation() {
         const response = await axiosInstance.get(
            '/admin/last-location/get'
        );
        return response.data;
    }

    async getCourierPerformance(courierId: number) {
        const response = await axiosInstance.get(
            '/admin/courier/performance/get?courierId='+ courierId,
        );
        return response.data;
    }
}